<div id="packer">
  <mat-slider [value]="percentValue" min="0" max="100" step="1" thumbLabel="true" [displayWith]="displayFunction" class="cdk-focused" [style.--slider-color]="sliderColor"> </mat-slider>
  <div id="labeler"><span>0%</span><span>20%</span><span class="hide">40%</span><span class="hide">60%</span><span>80%</span><span>100%</span></div>
</div>

